import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { RoleStatus } from "../../shared/Enum/RoleStatus";

export const getTransactionHistory = async (id: string, role: string) => {
  const dataAPI = await HttpService.post(
    `${ApiService.alesaForm.getTransactionHistory}`,
    JSON.stringify({
      RequestID: id,
      ShowInternal:
        role != RoleStatus.toId(RoleStatus.EndUser) &&
        role != RoleStatus.toId(RoleStatus.BusinessAndActivity),
    })
  );

  return dataAPI.data.data;
};
